require("!!/home/ubuntu/jenkins/workspace/7_9_Build/flavor/Pro/label_exp/docker-ec2-cloud/tmp/sugarbuild/sugarcrm/sidecar/node_modules/script-loader/addScript.js")(require("!!/home/ubuntu/jenkins/workspace/7_9_Build/flavor/Pro/label_exp/docker-ec2-cloud/tmp/sugarbuild/sugarcrm/sidecar/node_modules/raw-loader/index.js!/home/ubuntu/jenkins/workspace/7_9_Build/flavor/Pro/label_exp/docker-ec2-cloud/tmp/sugarbuild/sugarcrm/sidecar/node_modules/big.js/big.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/big.js/big.js
// module id = 29
// module chunks = 0